import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Iframe from './Iframe';
import { fetchOEmbed } from './utils';
import MediaStates from '../MediaStates';
var SUPPORTED_PROVIDERS = {
  drawio: /^((https?):\/\/)?(www\.)?draw.io/
};

var EmbedBlockInner =
/*#__PURE__*/
function (_Component) {
  _inherits(EmbedBlockInner, _Component);

  function EmbedBlockInner(props) {
    var _this;

    _classCallCheck(this, EmbedBlockInner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmbedBlockInner).call(this, props));
    _this.state = {
      title: '',
      provider: '',
      embedHtmlCode: '',
      hasError: false,
      loading: true
    };
    var url = props.url;

    var _ref = Object.entries(SUPPORTED_PROVIDERS).find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          provider = _ref4[0],
          regex = _ref4[1];

      return regex.test(url);
    }) || [],
        _ref2 = _slicedToArray(_ref, 1),
        provider = _ref2[0];

    if (provider) {
      _this.state.provider = provider;
      _this.state.loading = false;
    } else {
      _this.fetch(url);
    }

    return _this;
  }

  _createClass(EmbedBlockInner, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref5) {
      var url = _ref5.url;
      url !== this.props.url && this.fetch(url);
    }
  }, {
    key: "fetch",
    value: function fetch(url) {
      var _this2 = this;

      fetchOEmbed({
        url: url,
        iframelyApiKey: this.props.iframelyApiKey
      }).then(function (_ref6) {
        var html = _ref6.html,
            meta = _ref6.meta;
        var title = meta.title,
            site = meta.site,
            canonical = meta.canonical;
        var provider = site || canonical;

        if (!_this2.unmounted) {
          _this2.setState({
            title: title,
            provider: provider,
            embedHtmlCode: html,
            hasError: false,
            loading: false
          });

          _this2.props.onLoad({
            title: title,
            provider: provider
          });
        }
      })["catch"](function (error) {
        if (!_this2.unmounted) {
          _this2.setState({
            hasError: true,
            loading: false
          });

          _this2.props.onError(error);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          iframelyApiKey = _this$props.iframelyApiKey;
      var _this$state = this.state,
          title = _this$state.title,
          provider = _this$state.provider,
          embedHtmlCode = _this$state.embedHtmlCode,
          hasError = _this$state.hasError,
          loading = _this$state.loading;
      var shouldLoadScript = Boolean(iframelyApiKey);
      return React.createElement(Fragment, null, shouldLoadScript && React.createElement(Helmet, null, React.createElement("script", {
        charSet: "utf-8",
        src: "https://cdn.iframe.ly/embed.js?api_key=".concat(iframelyApiKey),
        async: true
      })), loading || hasError ? React.createElement(MediaStates, {
        loading: loading,
        mediaType: 'embed',
        error: hasError
      }) : React.createElement("div", {
        className: "background-shade-50"
      }, React.createElement(Iframe, {
        key: url,
        url: url,
        embedHtmlCode: embedHtmlCode,
        title: title,
        provider: provider
      })));
    }
  }]);

  return EmbedBlockInner;
}(Component);

_defineProperty(EmbedBlockInner, "propTypes", {
  iframelyApiKey: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onError: PropTypes.func
});

_defineProperty(EmbedBlockInner, "defaultProps", {
  onLoad: function onLoad() {},
  onError: function onError() {}
});

export default EmbedBlockInner;